import { render, staticRenderFns } from "./firstSection.vue?vue&type=template&id=44e4a0d6&scoped=true&"
var script = {}
import style0 from "./firstSection.vue?vue&type=style&index=0&id=44e4a0d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e4a0d6",
  null
  
)

export default component.exports